console.log('Hello World');

/*gsap.config({
    nullTargetWarn: false,
    trialWarn: false,
});*/

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

document.addEventListener('DOMContentLoaded', () => {

    console.log('DOMContentLoaded');

    let scrollSmoother = ScrollSmoother.create({
        smooth: 1,
        effects: true,
    });
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        });
    });

    // Mobile navigation toggle functionality
    const navToggle = document.getElementById('nav-toggle');
    var navMenu = document.getElementById('nav-menu');
    navToggle.addEventListener('click', function() {
        console.log('navToggle clicked');
        // Toggle hamburger animation
        navToggle.classList.toggle('active');
        console.log(navMenu.classList.contains('hidden'));
        // Toggle mobile menu visibility
        if (navMenu.classList.contains('hidden')) {
            navMenu.classList.remove('hidden');
            // Force a reflow to ensure the transition works
            navMenu.offsetHeight;
            navMenu.classList.add('visible');
            navMenu.classList.remove('hidden');
        } else {
            navMenu.classList.remove('visible');
            navMenu.classList.add('hidden');
            // Hide completely after animation
            setTimeout(() => {
                if (navMenu.classList.contains('hidden')) {
                    navMenu.classList.add('hidden');
                }
            }, 300);
        }
    });

    console.log('navMenu');
    console.log(navMenu);


    if (!navMenu) {
        navMenu = document.getElementById('nav-mobile');
    }
    console.log(navMenu);

    // Close mobile menu when clicking on a link
    const mobileLinks = navMenu.querySelectorAll('a');
    mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
            navToggle.classList.remove('active');
            navMenu.classList.remove('visible');
            navMenu.classList.add('hidden');
        });
    });

    // Close mobile menu when resizing to desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
            navToggle.classList.remove('active');
            navMenu.classList.add('hidden');
            navMenu.classList.remove('visible');
        }
    });

    // Handle keyboard accessibility
    navToggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navToggle.click();
        }
    });

    var sliderSwiper = new Swiper(".sliderSwiper", {
        slidesPerView: "auto",
        spaceBetween: 30,
        loop: true,
        speed: 600,
        autoplay: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        on: {
            beforeInit: function () {

            },
            init: function () {

            },
            slideChange: function () {
            },
        },

    });

    var ctaButtons = document.getElementsByClassName('cta-button');
    for (let i = 0; i < ctaButtons.length; i++) {
        ctaButtons[i].addEventListener('click', (e) => {
            console.log('ctaButton klick');
            e.preventDefault(); // Prevent default action if it's a link
            window.open('https://www.quartier-am-schwemmbach.de/wohnungsfinder/', '_blank');
        });
    }

    Comp6();
});


function Comp6() {
    console.log("Comp6");
    var tl6;
    if (document.querySelectorAll(".comp-6").length > 0) {
        var t = function (t) {
                return "+=".concat(window.innerHeight * (t / 100));
            },
            // Berechnung der Y-Verschiebung für die Liste - nach oben bewegen
            listHeight = document.querySelector(".comp-6-wrapper-list-content").offsetHeight,
            itemHeight = listHeight / 7,
            centerOffset = window.innerHeight / 2;

        tl6 = gsap.timeline({
            scrollTrigger: {
                trigger: ".comp-6-wrapper",
                start: "top top",
                end: t(360),
                scrub: false,
                pin: ".comp-6-wrapper",
                pinnedContainer: ".comp-6-wrapper",
                pinSpacing: true,
                //markers: {startColor:"green", endColor:"red", fontSize:"12px"}
            }
        });

        // Animation für die Liste - langsame Aufwärtsbewegung (negative Y-Werte)
        tl6.to(".comp-6-wrapper-list", {
            y: -listHeight * 0.6, // Negativer Wert für Aufwärtsbewegung
            ease: "none",
            scrollTrigger: {
                trigger: ".comp-6",
                start: t(0),
                end: t(300),
                scrub: false // Langsamere Animation
            }
        });

        // Bestehende Image-Animationen bleiben unverändert
        // Animation für 7 Content-Items mit ScrollTrigger
        const TOTAL_ITEMS = 7;
        const SCROLL_INTERVAL = 60;
        const BASE_SCROLL_POSITION = 30;
        const ANIMATION_OFFSET = 40;

        for (let currentItemIndex = 0; currentItemIndex < TOTAL_ITEMS; currentItemIndex++) {
            console.log('Processing item index:', currentItemIndex);

            // Berechnung der Scroll-Positionen für das aktuelle Item
            const itemStartScrollPosition = BASE_SCROLL_POSITION + SCROLL_INTERVAL * (currentItemIndex - 1);
            const itemEndScrollPosition = itemStartScrollPosition + ANIMATION_OFFSET;

            // CSS-Selektor für das aktuelle Item
            const currentItemSelector = `.comp-6-wrapper-content-item[data-item=item-${currentItemIndex + 1}] img`;

            // Clip-Path Definitionen für verschiedene Zustände
            const clipPathStates = {
                fullyVisible: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                hiddenBottom: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
                hiddenTop: "polygon(0 0, 100% 0, 100% 0, 0 0)",
                partiallyVisible: "polygon(0 100%, 100% 100%, 100% 0, 0 0)"
            };

            if (currentItemIndex === 0) {
                // Erstes Item: Fade-out Animation von unten
                tl6.fromTo(
                    currentItemSelector,
                    {
                        clipPath: clipPathStates.fullyVisible,
                        opacity: 1
                    },
                    {
                        clipPath: clipPathStates.hiddenBottom,
                        opacity: 0,
                        ease: "expoScale(0.5,7,none)",
                        scrollTrigger: {
                            trigger: ".comp-6",
                            start: t(3),
                            end: t(20),
                            scrub: true
                        }
                    }
                );

            } else if (currentItemIndex === TOTAL_ITEMS - 1) {
                // Letztes Item (Index 6): Spezielle Fade-in Animation
                tl6.fromTo(
                    currentItemSelector,
                    {
                        clipPath: clipPathStates.hiddenTop,
                        opacity: 0
                    },
                    {
                        clipPath: clipPathStates.partiallyVisible,
                        opacity: 1,
                        ease: "expoScale(0.5,7,none)",
                        scrollTrigger: {
                            trigger: ".comp-6",
                            start: t(itemStartScrollPosition),
                            end: t(25),
                            scrub: true
                        }
                    }
                );

            } else {
                // Mittlere Items (Index 1-5): Doppelte Animation (Fade-in und Fade-out)

                // Erste Animation: Fade-in von oben
                tl6.fromTo(
                    currentItemSelector,
                    {
                        clipPath: clipPathStates.hiddenTop,
                        opacity: 0
                    },
                    {
                        clipPath: clipPathStates.fullyVisible,
                        opacity: 1,
                        ease: "expoScale(0.5,7,none)",
                        scrollTrigger: {
                            trigger: ".comp-6",
                            start: t(itemStartScrollPosition),
                            end: t(25),
                            scrub: true
                        }
                    }
                );

                // Zweite Animation: Fade-out nach unten
                tl6.fromTo(
                    currentItemSelector,
                    {
                        clipPath: clipPathStates.partiallyVisible,
                        opacity: 0
                    },
                    {
                        clipPath: clipPathStates.hiddenBottom,
                        opacity: 0.5,
                        ease: "expoScale(0.5,7,none)",
                        scrollTrigger: {
                            trigger: ".comp-6",
                            start: t(itemEndScrollPosition),
                            end: t(20),
                            scrub: true
                        }
                    }
                );
            }
        }
        /*for (var o = 0; o < 7; o++) {
            var r = 30 + 60 * (o - 1),
                i = r + 40;
            0 === o
                ? tl6.fromTo(
                    ".comp-6-wrapper-content-item[data-item=item-".concat(o + 1, "] img"),
                    { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", opacity: 1 },
                    { clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)", opacity: 0, ease: "expoScale(0.5,7,none)", scrollTrigger: { trigger: ".comp-6", start: t(3), end: t(20), scrub: !0 } }
                )
                : 6 === o
                    ? tl6.fromTo(
                        ".comp-6-wrapper-content-item[data-item=item-".concat(o + 1, "] img"),
                        { clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)", opacity: 0 },
                        { clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0)", opacity: 1, ease: "expoScale(0.5,7,none)", scrollTrigger: { trigger: ".comp-6", start: t(r), end: t(25), scrub: !0 } }
                    )
                    : (tl6.fromTo(
                        ".comp-6-wrapper-content-item[data-item=item-".concat(o + 1, "] img"),
                        { clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)", opacity: 0 },
                        { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", opacity: 1, ease: "expoScale(0.5,7,none)", scrollTrigger: { trigger: ".comp-6", start: t(r), end: t(25), scrub: !0 } }
                    ),
                        tl6.fromTo(
                            ".comp-6-wrapper-content-item[data-item=item-".concat(o + 1, "] img"),
                            { clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0)", opacity: 1 },
                            { clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)", opacity: 0, ease: "expoScale(0.5,7,none)", scrollTrigger: { trigger: ".comp-6", start: t(i), end: t(20), scrub: !0 } }
                        ));
        }*/

        // Rest der Animationen bleibt unverändert...
        for (var s = 0; s < 8; s++) {
            var c = 30 + 50 * s;

            tl6.fromTo(
                ".comp-6-wrapper-list-content-item[data-item=item-".concat(s + 1, "] p"),
                { background: "linear-gradient(0, #BAD9B1 0%, #338157 0%)" },
                { background: "linear-gradient(180deg, #BAD9B1 0%, #338157 0%)", scrollTrigger: { trigger: ".comp-6", start: t(c), end: t(1), scrub: !0 } }
            ),
            6 === s ||
            tl6.fromTo(
                ".comp-6-wrapper-list-content-item[data-item=item-".concat(s + 1, "] p"),
                { opacity: 1, background: "linear-gradient(180deg, #BAD9B1 0, #338157 0%)" },
                { background: "linear-gradient(180deg, #BAD9B1 100%, #338157 0%)", opacity: 0.3, scrollTrigger: { trigger: ".comp-6", start: t(c), end: t(50), scrub: !0 } }
            ),
                tl6.fromTo(
                    ".comp-6-wrapper-list-content-item[data-item=item-".concat(s + 2, "] p"),
                    { opacity: 0.3, background: "linear-gradient(0, #BAD9B1 100%, #338157 0%)" },
                    { background: "linear-gradient(0, #BAD9B1 0%, #338157 0%)", opacity: 1, scrollTrigger: { trigger: ".comp-6", start: t(c), end: t(50), scrub: !0 } }
                );
        }

        [
            { startOpacity: 0.3, endOpacity: 0.1, start: 80, items: "item-1" },
            { startOpacity: 0.1, endOpacity: 0.05, start: 130, items: "item-1" },
            { startOpacity: 0.3, endOpacity: 0.1, start: 130, items: "item-2" },
            { startOpacity: 0.1, endOpacity: 0.05, start: 180, items: "item-2" },
            { startOpacity: 0.1, endOpacity: 0.3, start: 30, items: "item-3" },
            { startOpacity: 0.3, endOpacity: 0.1, start: 180, items: "item-3" },
            { startOpacity: 0.1, endOpacity: 0.05, start: 230, items: "item-3" },
            { startOpacity: 0.05, endOpacity: 0.1, start: 30, items: "item-4" },
            { startOpacity: 0.1, endOpacity: 0.3, start: 80, items: "item-4" },
            { startOpacity: 0.3, endOpacity: 0.1, start: 230, items: "item-4" },
            { startOpacity: 0.1, endOpacity: 0.05, start: 280, items: "item-4" },
            { startOpacity: 0.05, endOpacity: 0.1, start: 80, items: "item-5" },
            { startOpacity: 0.1, endOpacity: 0.3, start: 130, items: "item-5" },
            { startOpacity: 0.3, endOpacity: 0.1, start: 280, items: "item-5" },
            { startOpacity: 0.05, endOpacity: 0.1, start: 130, items: "item-6" },
            { startOpacity: 0.1, endOpacity: 0.3, start: 180, items: "item-6" },
            { startOpacity: 0.05, endOpacity: 0.1, start: 180, items: "item-7" },
            { startOpacity: 0.1, endOpacity: 0.3, start: 230, items: "item-7" },
        ].map(function (e) {
            tl6.fromTo(".comp-6-wrapper-list-content-item[data-item=".concat(e.items, "] p"), { opacity: e.startOpacity }, { opacity: e.endOpacity, scrollTrigger: { trigger: ".comp-6", start: t(e.start), end: t(50), scrub: !0 } });
        });

        setTimeout(function () {
            console.log("setTimeout setTimeout");
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-1] p", { background: "linear-gradient(180deg,  #338157 0%, #338157 0%)", opacity: 1 });
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-2] p", { background: "linear-gradient(0,  #338157 100%, #338157 0%)", opacity: 0.3 });
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-3] p", { background: "linear-gradient(0,  #338157 100%, #338157 0%)", opacity: 0.1 });
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-4] p", { background: "linear-gradient(0,  #338157 100%, #338157 0%)", opacity: 0.05 });
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-5] p", { background: "linear-gradient(0,  #338157 100%, #338157 0%)", opacity: 0.05 });
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-6] p", { background: "linear-gradient(0,  #338157 100%, #338157 0%)", opacity: 0.05 });
            gsap.set(".comp-6-wrapper-list-content-item[data-item=item-7] p", { background: "linear-gradient(0,  #338157 100%, #338157 0%)", opacity: 0.05 });
            gsap.set(".comp-6-wrapper-list", { y: 0 });
            gsap.set(".comp-6-wrapper-content-item img", { clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)", opacity: 0 });
            gsap.set(".comp-6-wrapper-content-item[data-item=item-1] img", { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", opacity: 1 });
        }, 2000);
    }
}
